import { render, staticRenderFns } from "./T_SettingThirdPartyService_NewebPay.vue?vue&type=template&id=200c2e21&scoped=true&"
import script from "./T_SettingThirdPartyService_NewebPay.vue?vue&type=script&lang=js&"
export * from "./T_SettingThirdPartyService_NewebPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200c2e21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200c2e21')) {
      api.createRecord('200c2e21', component.options)
    } else {
      api.reload('200c2e21', component.options)
    }
    module.hot.accept("./T_SettingThirdPartyService_NewebPay.vue?vue&type=template&id=200c2e21&scoped=true&", function () {
      api.rerender('200c2e21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/setting/T_SettingThirdPartyService_NewebPay.vue"
export default component.exports